
export const SET_LASTMESSAGES = (state, lastmessages) =>{

    state.lastmessages = lastmessages;
}